import * as React from "react";

import { cn } from "@/lib/utils";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        "relative overflow-hidden rounded-md bg-white/[0.04]",
        "bg-[linear-gradient(90deg,transparent,color-mix(in_oklab,var(--color-accent-neon)_14%,transparent),transparent)] bg-[length:200%_100%] motion-safe:animate-[sheen_1.6s_linear_infinite] motion-reduce:animate-pulse",
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
